import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { CommonUtility } from './utility';

/**
 * Generic CRUD base for feature services — same surface as the Angular 13
 * workspace's CRUDService so migrated services keep working unchanged
 * (subclasses call `super(baseService, APIConstant.xyz)`).
 */
export class CRUDService<T> {

    protected apiPath = '';

    constructor(protected baseService: BaseService, name = 'master') {
        this.apiPath = name;
    }

    get(params?: { [key: string]: any }): Observable<T[]> {
        let url: string = this.apiPath;
        const query = params ? CommonUtility.convertObjectToParams(params).toString() : '';
        if (query) {
            url += `?${query}`;
        }
        return this.baseService.get<T[]>(url);
    }

    getById(id: number): Observable<T> {
        return this.baseService.get<T>(`${this.apiPath}/${id}`);
    }

    add(data: T, isOverrideApplied = false): Observable<T> {
        let url: string = this.apiPath.replace(/\/$/, '');
        if (isOverrideApplied) {
            url += `?isOverrideApplied=${isOverrideApplied}`;
        }
        return this.baseService.post<T>(url, data);
    }

    update(id: number, data: T, isOverrideApplied = false): Observable<T> {
        let url: string = this.apiPath.replace(/\/$/, '');
        if (id) {
            url += `/${id}`;
        }
        if (isOverrideApplied) {
            url += `?isOverrideApplied=${isOverrideApplied}`;
        }
        return this.baseService.put<T>(url, data);
    }

    remove(id: number): Observable<any> {
        return this.baseService.delete<any>(`${this.apiPath}/${id}`);
    }

    removeByParams(params?: { [key: string]: any }): Observable<T[]> {
        let url: string = this.apiPath;
        const query = params ? CommonUtility.convertObjectToParams(params).toString() : '';
        if (query) {
            url += `?${query}`;
        }
        return this.baseService.delete<any>(url);
    }
}
